import React, {useCallback, useRef} from 'react';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIconUrl from "leaflet/dist/images/marker-icon.png";
import markerIconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import markerShadowUrl from "leaflet/dist/images/marker-shadow.png";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";

const markerIcon = new L.Icon({
    iconUrl: markerIconUrl,
    iconRetinaUrl: markerIconRetinaUrl,
    shadowUrl: markerShadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
});

const FALLBACK_VIEW = [[-15.79, -47.88], 4];

const InstallerMapModal = ({open, setOpen, latitude, longitude, onSelect}) => {
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const onSelectRef = useRef(onSelect);
    const coordsRef = useRef({latitude, longitude});

    onSelectRef.current = onSelect;
    coordsRef.current = {latitude, longitude};

    const setContainer = useCallback((node) => {
        if (!node) {
            mapRef.current?.remove();
            mapRef.current = null;
            markerRef.current = null;
            return;
        }

        const map = L.map(node).setView(...FALLBACK_VIEW);
        mapRef.current = map;

        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);

        map.on("click", (event) => {
            if (markerRef.current) map.removeLayer(markerRef.current);

            markerRef.current = new L.Marker(event.latlng, {icon: markerIcon}).addTo(map);
            onSelectRef.current(event.latlng.lat, event.latlng.lng);
        });

        const lat = parseFloat(coordsRef.current.latitude);
        const lng = parseFloat(coordsRef.current.longitude);

        if (!isNaN(lat) && !isNaN(lng)) {
            markerRef.current = new L.Marker([lat, lng], {icon: markerIcon}).addTo(map);
            map.setView([lat, lng], 16);
        } else {
            map.locate({setView: true, maxZoom: 16});
        }

        map.invalidateSize();
    }, []);

    return (
        <Modal open={open} setOpen={setOpen} title={"Mapa"} className={"w-10/12"}>
            <Modal.Body>
                <div ref={setContainer} id={"installer-map"} className={"h-[80vh] w-full"} />
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={() => setOpen(false)}>Ok</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InstallerMapModal;
